// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"37475e42","239":"4bed0202","455":"c892b0df"}[chunkId] + ".chunk.js";
};